import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { action } from 'satcheljs';
import type { DisplayDate } from 'owa-datetime';

export let initializeCustomRecurrenceForm = action(
    'initializeCustomRecurrenceForm',
    (recurrence: RecurrenceType, startDate: DisplayDate, formId: string) => ({
        recurrence,
        startDate,
        formId,
    })
);

export let hideCustomRecurrenceForm = action('hideCustomRecurrenceForm', (formId: string) => ({
    formId,
}));

export let updateCustomRecurrenceFormRecurrenceType = action(
    'updateCustomRecurrenceFormRecurrenceType',
    (recurrence: RecurrenceType, formId: string) => ({
        recurrence,
        formId,
    })
);

export let updateCustomRecurrenceFormStartDate = action(
    'updateCustomRecurrenceFormStartDate',
    (startDate: DisplayDate, formId: string) => ({
        startDate,
        formId,
    })
);

export let saveCustomRecurrence = action('saveCustomRecurrence', (formId: string) => ({
    formId,
}));
